export const colors = {
    error: '#FF9494'
}